<script setup>
import { __, getFormValuesFromLocalStorage, numbersType } from '@/utils';
import { inject, ref } from 'vue';
import IconSmartphone from '@components/icons/icon-smartphone.vue';
import IconStep1 from '@components/icons/icon-step1.vue';
import IconStep2 from '@components/icons/icon-step2.vue';
import IconStep3 from '@components/icons/icon-step3.vue';

const { registrationData } = inject('step');

const localStorageValues = getFormValuesFromLocalStorage();
const clientType = localStorageValues.activeTab === 'Business Client' ? 'company' : 'subscriber';
const shippingMethod = localStorageValues[`${clientType}ShippingMethod`];

const cleanLocalStorage = () => {
    // cleanup
    localStorage.removeItem('formValues');
    localStorage.removeItem('formFragmentValues');
}

const message = ref(registrationSuccess.sim)
const messagePorted = ref(registrationSuccess.sim_ported)
const messageMixed= ref(registrationSuccess.sim_mixed)
</script> 
<template>

    <p>{{ __('Numbers:') }}</p>
    <div class="number-boxes">
        <div class="number-box" v-for="number in registrationData.subscribers" :key="number.id">
            <div class="pill">
                <div class="pill__inner">
                    <span>
                        {{ number.msisdn }}
                    </span>
                    <div class="pill__icon">
                        <IconSmartphone />
                    </div><!-- /.pill__icon -->
                </div>
            </div>
        </div>
    </div>
    <p>
        {{ __('You have selected physical SIM card, so they can be activated when they arrive') }}
        <br/>
        ({{ shippingMethod === 'regular' ? __('Israel Post - up to 7 business days') : __('Home delivery - up to 3 business days') }})
    </p>
    <p v-if="numbersType(registrationData.subscribers) === 'new_line'">
       <span v-html="message"></span>
    </p>
    <p v-if="numbersType(registrationData.subscribers) === 'ported'">
       <span v-html="messagePorted"></span>
    </p>
    <p v-if="numbersType(registrationData.subscribers) === 'mixed'">
       <span v-html="messageMixed"></span>
    </p>
    
    <div class="sim-steps">
        <div class="sim-step">
            <div class="sim-step__arrow">
                <span></span>
            </div>
            <h3 class="gradient">01</h3>
            <div class="sim-step__image">
                <IconStep1 />
            </div>
            <h4>{{ __('The SIM arrived by delivery') }}</h4>
            <p>{{ shippingMethod === 'regular' ? __('Israel Post - up to 7 business days') : __('Home delivery - up to 3 business days') }}</p>
        </div>
        <div class="sim-step">
            <div class="sim-step__arrow">
                <span></span>
            </div>
            <h3 class="gradient">02</h3>
            <div class="sim-step__image">
                <IconStep2 />
            </div>
            <h4>{{ __('Get the sim and activate') }}</h4>
            <p>{{ __('Follow the instructions attached to the shipment, and in any case our call center is here for you') }}</p>
        </div>
        <div class="sim-step">
            <h3 class="gradient">03</h3>
            <div class="sim-step__image">
                <IconStep3 />
            </div>
            <h4>{{ __('Connect to XPhone') }}</h4>
            <p>{{ __("And that's it, you're connected") }}</p>
        </div>
    </div>

    <a href="/" class="btn btn--arrows" @click="cleanLocalStorage">
        {{ __('Back to Home page') }}
    </a>
</template>